import { createSelector } from '@reduxjs/toolkit';
import { getOrganization } from '../organization/getOrganization';
import type { FeatureStates } from '../featureStates';

import { featuresAndSubfeatures } from './featuresAndSubfeatures';

export const getFeatureStates = createSelector(getOrganization, function (organization): FeatureStates {
  const features = organization?.features ?? [];
  const states = {
    meetings: features.includes('MEETINGS'),
    performanceReview: features.includes('PERFORMANCE_REVIEW'),
    staffing: features.includes('STAFFING'),
    assets: features.includes('ASSETS'),
    substances: features.includes('SUBSTANCES'),
    issues: features.includes('ISSUES'),
    risk: features.includes('RISK'),
    data: features.includes('DATA'),
    quality: features.includes('QUALITY'),
    healthcare: features.includes('HEALTHCARE'),
    core: features.includes('CORE'),
    mini: features.includes('CORE') && features.includes('MEETINGS'),
    signing: features.includes('SIGNING'),
    collections: features.includes('COLLECTIONS'),
    hse: features.includes('HSE_CONTENT'),
    // Pure HMS-product customers carry the `HSE` bundle code (distinct from the
    // `HSE_CONTENT` sub-feature above). Used to gate functionality meant only
    // for these customers — Komplett bundles do not carry `HSE`.
    hseProduct: features.includes('HSE'),
    video: features.includes('VIDEO'),
    ask: features.includes('ASK'),
    norengros:
      features.includes('NORENGROS') || features.includes('NORENGROS-NEW') || features.includes('NORENGROS-EXISTING'),
    privateNotes: features.includes('PRIVATE_NOTES'),
    ncc: features.includes('NCC'),
    // Kriseberedskap ligger ikke lenger bak et feature flagg – funksjonen er
    // tilgjengelig for alle organisasjoner uavhengig av EMERGENCY-featuren.
    emergency: true,
    matrix: features.includes('MATRIX'),
    signage: features.includes('SIGNAGE'),
    managementDashboard: features.includes('MANAGEMENT_DASHBOARD'),
  };
  return featuresAndSubfeatures(states);
});
